import {
  useGetJobLogByExecutionIdSuspense,
  useGetLogsByExecutionIdSuspense,
} from "@/orval/gen"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { LabeledValue } from "@components/default-list/labeled-value"
import { Page } from "@components/Page"
import { Table, TableData } from "@mantine/core"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/app/admin-settings/automatic-background-jobs/logs/$executionId"
)({
  component: RouteComponent,
  beforeLoad: () => ({ getTitle: () => "Log Details" }),
})

function RouteComponent() {
  const { executionId } = Route.useParams()
  const { data: job } = useGetJobLogByExecutionIdSuspense({
    executionId: executionId,
  })
  const { data: logs } = useGetLogsByExecutionIdSuspense({
    executionId: executionId,
  })
  const logTableData: TableData = {
    head: ["Id", "Timestamp", "Level", "Message"],
    body: logs.map((log) => [
      log.id,
      getFormattedDate(log.timeStamp, "L LTS"),
      log.level,
      log.message,
    ]),
  }
  return (
    <Page>
      <LabeledValue label="Job Name" value={job.name} />
      <LabeledValue label="Job Type" value={job.jobType} />
      <LabeledValue label="Execution Id" value={executionId} />
      <Table data={logTableData} />
    </Page>
  )
}
